import { render, staticRenderFns } from "./ListaProductosApp.vue?vue&type=template&id=bc7867e4"
import script from "./ListaProductosApp.vue?vue&type=script&lang=js"
export * from "./ListaProductosApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports